import React from 'react'

function ExploreBtn() {
    return (
        <div className="text-center">
            <a href="#showevent" className="ebtn">
                Explore Events 
                <br></br> 
                <i className="fa fa-arrow-down"></i> 
            </a>
        </div>
    )
}

export default ExploreBtn
